/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentCategoriesEditViewComponent(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    ContentEditService: JS5Object,
    ModalService: JS5Object,
    NotificationService: JS5Object,
    PermissionsService: JS5Object,
    SubscriptionsService: JS5Object
) {

    //=============//
    // HTML Events //
    //=============//

    this.onTabSelect = (tabName: string) => {
        if (this.viewTab && tabName === $location.search().viewTab) {
            return;
        }
        if (this.viewTab && tabName !== $location.search().viewTab || !$location.search().viewTab) {
            $location.search('viewTab', tabName);
            this.viewTab = tabName;
        } else {
            this.viewTab = $location.search().viewTab;
        }
        this.searchEnabled = this.viewTab === 'subscriptions';
        this.filterEnabled = this.viewTab === 'subscriptions';
    };

    this.onTabDeselect = (tabName: string, event: JS5Object) => {
        let preventLeave: boolean;
        switch (tabName) {
            case 'properties':
                preventLeave = ContentEditService.contentCategoryObject && ContentEditService.contentCategoryObject.id && ContentEditService.editorForm && ContentEditService.editorForm.$dirty;
                break;
            case 'subscriptions':
                preventLeave = SubscriptionsService.editorForm && SubscriptionsService.editorForm.$dirty;
                break;
            default:
                preventLeave = false;
                break;
        }
        if (preventLeave) {
            event.preventDefault();
            NotificationService.createWarningNotification(
                'Please save or revert your changes before navigating away from this page.'
            );
        }
    };

    this.subscriptionsDisabled = () => {
        return !ContentEditService.contentCategoryObject || (this.viewTab === 'properties' && ContentEditService.contentCategoryObject.id < 0);
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        ContentEditService.contentType = this.contentType;
        ContentEditService.resetBreadcrumbs();
        // Add the content breadcrumb
        this.contentBreadcrumb = {
            location: '',
            name: '',
            params: null,
        };
        this.categoryBreadcrumb = {
            location: '',
            name: '',
            params: null,
        };
        BreadcrumbService.addBreadcrumb(this.contentBreadcrumb);
    };

    this.$onDestroy = () => {
        $location.search('viewTab', null);
    };
}

angular.module('prism-ui.content').component('contentCategoriesEditView', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/content-categories-edit-view-template.html',
    controller: ContentCategoriesEditViewComponent,
    bindings: {
        contentType: '<'
    }
});
